import React, { useState } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsiveLine } from "@nivo/line";
import styled from "styled-components";
 
function GraphComponent({ data }) {
  const [chartType, setChartType] = useState('line');
  if (!data) return null;
 
  const forecast = data["Forecast"][0];
  const qty = data["Quantity to be ordered"][0];
 
  // Bar chart data
  const barData = Object.keys(forecast).map((key) => ({
    period: key,
    Forecast: forecast[key],
    "Qty to Order": qty[key],
  }));
 
  // Line chart data
  const lineData = [
    {
      id: "Forecast",
      color: "#032B4E",
      data: Object.keys(forecast).map((key) => ({ x: key, y: forecast[key] })),
    },
    {
      id: "Qty to Order",
      color: "#b8842f",
      data: Object.keys(qty).map((key) => ({ x: key, y: qty[key] })),
    },
  ];
 
  return (
    <Wrapper>
      <Card>
        <h2 className="chart-title">Inventory Analysis</h2>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 18 }}>
          {/* <button
            onClick={() => setChartType('line')}
            style={{
              background: chartType === 'line' ? '#032B4E' : '#e2e8f0',
              color: chartType === 'line' ? '#fff' : '#032B4E',
              border: 'none',
              borderRadius: '8px 0 0 8px',
              padding: '10px 22px',
              fontWeight: 600,
              fontSize: 16,
              cursor: 'pointer',
              boxShadow: chartType === 'line' ? '0 2px 8px rgba(3,43,78,0.10)' : 'none',
              outline: 'none',
              transition: 'background 0.2s',
            }}
          >
            Line Chart
          </button> */}
          {/* <button
            onClick={() => setChartType('bar')}
            style={{
              background: chartType === 'bar' ? '#032B4E' : '#e2e8f0',
              color: chartType === 'bar' ? '#fff' : '#032B4E',
              border: 'none',
              borderRadius: '0 8px 8px 0',
              padding: '10px 22px',
              fontWeight: 600,
              fontSize: 16,
              cursor: 'pointer',
              boxShadow: chartType === 'bar' ? '0 2px 8px rgba(3,43,78,0.10)' : 'none',
              outline: 'none',
              transition: 'background 0.2s',
            }}
          >
            Bar Chart
          </button> */}
        </div>
        <div className="chart-wrapper">
          {chartType === 'bar' ? (
            <ResponsiveBar
              data={barData}
              keys={["Forecast", "Qty to Order"]}
              indexBy="period"
              groupMode="grouped"
              margin={{ top: 50, right: 160, bottom: 80, left: 80 }}
              padding={0.2}
              innerPadding={4}
              valueScale={{ type: "linear" }}
              indexScale={{ type: "band", round: true }}
              colors={["#032B4E", "#b8842f"]}
              borderRadius={6}
              borderWidth={3}
              borderColor={{
                from: "color",
                modifiers: [["darker", 0.4]],
              }}
              axisTop={null}
              axisRight={null}
              axisBottom={{
                tickSize: 8,
                tickPadding: 8,
                tickRotation: 0,
                legend: "Time Period",
                legendPosition: "middle",
                legendOffset: 40,
                tickTextColor: "#032B4E",
                legendTextColor: "#032B4E",
              }}
              axisLeft={{
                tickSize: 8,
                tickPadding: 8,
                tickRotation: 0,
                legend: "Quantity",
                legendPosition: "middle",
                legendOffset: -70,
                tickTextColor: "#032B4E",
                legendTextColor: "#032B4E",
              }}
              enableGridY={true}
              gridYValues={6}
              enableLabel={true}
              labelSkipWidth={8}
              labelSkipHeight={8}
              labelTextColor="#ffffff"
              labelFormat={(value) => `${value.toLocaleString()}`}
              labelComponent={({ value, x, y, width, height, color }) => (
                <text
                  x={x + width / 2}
                  y={y + height / 2}
                  textAnchor="middle"
                  dominantBaseline="central"
                  style={{
                    fill: '#ffffff',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
                  }}
                >
                  {value.toLocaleString()}
                </text>
              )}
              legends={[
                {
                  dataFrom: "keys",
                  anchor: "bottom-right",
                  direction: "column",
                  justify: false,
                  translateX: 140,
                  translateY: 0,
                  itemsSpacing: 15,
                  itemWidth: 130,
                  itemHeight: 30,
                  itemDirection: "left-to-right",
                  itemOpacity: 1,
                  symbolSize: 24,
                  itemTextColor: "#032B4E",
                  symbolBorderWidth: 2,
                  symbolBorderColor: "#032B4E",
                  effects: [
                    {
                      on: "hover",
                      style: {
                        itemOpacity: 0.8,
                        itemTextColor: "#b8842f",
                      },
                    },
                  ],
                },
              ]}
              animate={true}
              motionConfig="slow"
              role="application"
              ariaLabel="Inventory bar chart"
              barAriaLabel={(e) =>
                `${e.id}: ${e.formattedValue} in period: ${e.indexValue}`
              }
              theme={{
                background: '#ffffff',
                textColor: '#0F1116',
                fontSize: 14,
                fontFamily: 'Inter, sans-serif',
                axis: {
                  domain: {
                    line: {
                      stroke: '#032B4E',
                      strokeWidth: 2,
                    },
                  },
                  legend: {
                    text: {
                      fontSize: 16,
                      fontWeight: 600,
                      fontFamily: 'Poppins, sans-serif',
                      fill: '#0F1116',
                    },
                  },
                  ticks: {
                    line: {
                      stroke: '#032B4E',
                      strokeWidth: 2,
                    },
                    text: {
                      fontSize: 13,
                      fontWeight: 500,
                      fontFamily: 'Inter, sans-serif',
                      fill: '#374151',
                    },
                  },
                },
                grid: {
                  line: {
                    stroke: '#e2e8f0',
                    strokeWidth: 1,
                  },
                },
                legends: {
                  text: {
                    fontSize: 14,
                    fontWeight: 600,
                    fontFamily: 'Inter, sans-serif',
                    fill: '#0F1116',
                  },
                },
              }}
            />
          ) : (
            <ResponsiveLine
              data={lineData}
              margin={{ top: 50, right: 160, bottom: 80, left: 100 }}
              xScale={{ type: 'point' }}
              yScale={{ type: 'linear', min: 0, max: 'auto', stacked: false, reverse: false }}
              axisTop={null}
              axisRight={null}
              axisBottom={{
                tickSize: 8,
                tickPadding: 8,
                tickRotation: 0,
                legend: 'Time Period',
                legendPosition: 'middle',
                legendOffset: 55,
                tickTextColor: '#032B4E',
                legendTextColor: '#032B4E',
              }}
              axisLeft={{
                tickSize: 8,
                tickPadding: 8,
                tickRotation: 0,
                legend: 'Quantity',
                legendPosition: 'middle',
                legendOffset: -85,
                tickTextColor: '#032B4E',
                legendTextColor: '#032B4E',
              }}
              colors={["#032B4E", "#b8842f"]}
              pointSize={12}
              pointColor={{ theme: 'background' }}
              pointBorderWidth={3}
              pointBorderColor={{ from: 'serieColor' }}
              enableGridY={true}
              gridYValues={6}
              enableArea={false}
              useMesh={true}
              legends={[{
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 140,
                translateY: 0,
                itemsSpacing: 15,
                itemWidth: 130,
                itemHeight: 30,
                itemDirection: 'left-to-right',
                itemOpacity: 1,
                symbolSize: 24,
                itemTextColor: '#032B4E',
                symbolBorderWidth: 2,
                symbolBorderColor: '#032B4E',
                effects: [
                  {
                    on: 'hover',
                    style: {
                      itemOpacity: 0.8,
                      itemTextColor: '#b8842f',
                    },
                  },
                ],
              }]}
              theme={{
                background: '#ffffff',
                textColor: '#0F1116',
                fontSize: 14,
                fontFamily: 'Inter, sans-serif',
                axis: {
                  domain: {
                    line: {
                      stroke: '#032B4E',
                      strokeWidth: 2,
                    },
                  },
                  legend: {
                    text: {
                      fontSize: 16,
                      fontWeight: 600,
                      fontFamily: 'Poppins, sans-serif',
                      fill: '#0F1116',
                    },
                  },
                  ticks: {
                    line: {
                      stroke: '#032B4E',
                      strokeWidth: 2,
                    },
                    text: {
                      fontSize: 13,
                      fontWeight: 500,
                      fontFamily: 'Inter, sans-serif',
                      fill: '#374151',
                    },
                  },
                },
                grid: {
                  line: {
                    stroke: '#e2e8f0',
                    strokeWidth: 1,
                  },
                },
                legends: {
                  text: {
                    fontSize: 14,
                    fontWeight: 600,
                    fontFamily: 'Inter, sans-serif',
                    fill: '#0F1116',
                  },
                },
              }}
              animate={true}
              motionConfig="slow"
              role="application"
              ariaLabel="Inventory line chart"
              enableSlices="x"
            />
          )}
        </div>
      </Card>
    </Wrapper>
  );
}
 
export default GraphComponent;
 
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 600px;
`;
 
const Card = styled.div`
  width: 100%;
  max-width: 1250px;
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  padding: 40px 50px 60px;
  text-align: center;
  border: 2px solid #1F4280;
  position: relative;
  overflow: hidden;
 
  .chart-title {
    font-size: 28px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    color: #0F1116;
    margin-bottom: 35px;
    text-align: center;
    letter-spacing: 0px;
    position: relative;
    text-shadow: 0 2px 4px rgba(3, 43, 78, 0.1);
   
    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #032B4E, #b8842f);
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(3, 43, 78, 0.3);
    }
  }
 
  .chart-wrapper {
    height: 520px;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
    padding: 25px;
    border: 2px solid #1F4280;
    position: relative;
    overflow: visible;
   
    &::before {
      content: '';
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      background: linear-gradient(45deg, #032B4E15, #b8842f15);
      border-radius: 20px;
      z-index: -1;
    }
  }
 
  .chart-wrapper > div {
    height: 100% !important;
  }
`;